import {INewBusiness} from "@/views/editor/service/business";
import Atmosphere from "@/views/editor/service/atmosphere/atmosphere/index";
import Shield from "@/views/editor/service/atmosphere/shield";

export default {'atmosphere': Atmosphere, 'shield': Shield} as { [key: string]: INewBusiness }